/**
 * Internal dependencies
 */
import ViewportManager from "./viewport-manager";

/**
 * @todo Mettre en place un objet slider hors block afin de s'appuyer sur la même base lorsqu'on souhaite faire du slider custom
 * hors système de block.
 */
class BlockSlider {

	/**
	 * Public vars
	 */
	contextDocument = document;
	element = null;
	navigationElement = null;
	scrollbarElement = null;
	swiper = null;
	swiperWrapperSelector = ':scope > .block-list';
	swiperSlideSelector = ':scope > .block-list > .block-slide';

	/**
	 * 
	 * @param {HTMLElement} element 
	 */
	constructor( element )
	{
		this.element = element;
		this.init();
	}

	/**
	 * 
	 */
	init()
	{
		this.onBeforeSlideChange = this.onBeforeSlideChange.bind( this );
		this.onSlideChange = this.onSlideChange.bind( this );
		this.onSwiperInit = this.onSwiperInit.bind( this );
		this.onVideoClick = this.onVideoClick.bind( this );
	}

	/**
	 * 
	 */
	clear()
	{
		this.swiper.destroy( true, true );
		delete this.element.wmuBlockSlider;

		this.removeSwiperClasses();

		if ( null !== this.navigationElement )
		{
			this.navigationElement.remove();
		}

		if ( null !== this.scrollbarElement )
		{
			this.scrollbarElement.remove();
		}

		this.element.querySelectorAll( 'video' ).forEach( ( video ) =>
		{
			video.removeEventListener( 'click', this.onVideoClick );
		} );
	}

	/**
	 * 
	 * @param {String} viewport 
	 */
	getSettings( viewport )
	{
		let settings = this.element.getAttribute( `${viewport}-settings` );
		return ( settings ) ? JSON.parse( settings ) : null;
	}

	/**
	 * 
	 */
	addSwiperClasses()
	{
		this.element.classList.add( 'swiper', 'swiper-container' );

		const wrapper = this.element.querySelector( this.swiperWrapperSelector );
		if ( wrapper )
		{
			wrapper.classList.add( 'swiper-wrapper' );
		}

		this.element.querySelectorAll( this.swiperSlideSelector ).forEach( ( slideElement ) =>
		{
			slideElement.classList.add( 'swiper-slide' );
		} );
	}

	/**
	 * 
	 */
	removeSwiperClasses()
	{
		this.element.classList.remove( 'swiper', 'swiper-container', 'swiper-has-nav', 'swiper-has-scrollbar' );

		const wrapper = this.element.querySelector( this.swiperWrapperSelector );
		if ( wrapper )
		{
			wrapper.classList.remove( 'swiper-wrapper' );
		}

		this.element.querySelectorAll( this.swiperSlideSelector ).forEach( ( slideElement ) =>
		{
			slideElement.classList.remove( 'swiper-slide' );
		} );
	}

	/**
	 * 
	 */
	setup()
	{
		const viewportCurrent = ViewportManager.viewportCurrent.toLowerCase();
		const settings = this.getSettings( viewportCurrent );

		this.addSwiperClasses();
		this.setupSlides( viewportCurrent );

		if ( settings.navigation )
		{
			this.createNavigation();
			settings.navigation = {
				nextEl: '.swiper-button-next',
				prevEl: '.swiper-button-prev',
			};
		}

		if ( settings.scrollbar )
		{
			this.createScrollbar();
			settings.scrollbar = {
				el: '.swiper-scrollbar',
				draggable: true,
			};
		}

		settings.on = {
			init: this.onSwiperInit
		};

		this.swiper = new Swiper( this.element, settings );
		this.element.wmuBlockSlider = this;

		this.swiper.on( 'slideChangeTransitionEnd', this.onSlideChange );
		this.swiper.on( 'slideChangeTransitionStart', this.onBeforeSlideChange );
	}

	/**
	 * 
	 * @param {String} viewport 
	 */
	setupSlides( viewport )
	{
		this.element.querySelectorAll( this.swiperSlideSelector ).forEach( ( slideElement ) =>
		{
			const autoplayDelay = slideElement.getAttribute( `${viewport}-ap-delay` );

			if ( autoplayDelay )
			{
				slideElement.setAttribute( 'data-swiper-autoplay', autoplayDelay );
			}
			else
			{
				slideElement.removeAttribute( 'data-swiper-autoplay' );
			}
		} );
	}

	/**
	 * 
	 */
	createNavigation()
	{
		this.navigationElement = this.contextDocument.createElement( 'div' );
		this.navigationElement.classList.add( 'swiper-navigation' );

		const prevElement = this.contextDocument.createElement( 'div' );
		prevElement.classList.add( 'swiper-button-prev' );

		const prevTextElement = this.contextDocument.createElement( 'span' );
		prevTextElement.classList.add( 'text', 'screen-reader-text' );
		/**
		 * @todo Passer le texte en variable
		 */
		prevTextElement.innerHTML = "Précédent";
		prevElement.appendChild( prevTextElement );

		const nextElement = this.contextDocument.createElement( 'div' );
		nextElement.classList.add( 'swiper-button-next' );

		const nextTextElement = this.contextDocument.createElement( 'span' );
		nextTextElement.classList.add( 'text', 'screen-reader-text' );
		/**
		 * @todo Passer le texte en variable
		 */
		nextTextElement.innerHTML = "Suivant";
		nextElement.appendChild( nextTextElement );
		
		this.navigationElement.appendChild( prevElement );
		this.navigationElement.appendChild( nextElement );
		this.element.appendChild( this.navigationElement );

		this.element.classList.add( 'swiper-has-nav' );
	}

	/**
	 * 
	 */
	createScrollbar()
	{
		this.scrollbarElement = this.contextDocument.createElement( 'div' );
		this.scrollbarElement.classList.add( 'swiper-scrollbar' );
		this.element.appendChild( this.scrollbarElement );

		this.element.classList.add( 'swiper-has-scrollbar' );
	}

	/**
	 * 
	 * @param {Swiper} swiper 
	 */
	onSwiperInit( swiper )
	{
		this.element.querySelectorAll( 'video' ).forEach( ( video ) =>
		{
			video.addEventListener( 'click', this.onVideoClick );
		} );
	}

	/**
	 * 
	 * @param {Swiper} swiper 
	 */
	onBeforeSlideChange( swiper )
	{
		const count = swiper.slides.length;

		for ( let i = 0; i < count; i++ )
		{
			const slide = swiper.slides[i];
			slide.querySelectorAll( 'video' ).forEach( ( video ) =>
			{
				video.pause();

				if ( i === swiper.activeIndex )
				{
					video.currentTime = 0;
				}
			} );
		}
	}

	/**
	 * 
	 * @param {Swiper} swiper 
	 */
	onSlideChange( swiper )
	{
		const count = swiper.slides.length;

		for ( let i = 0; i < count; i++ )
		{
			const slide = swiper.slides[i];
			slide.querySelectorAll( 'video' ).forEach( ( video ) =>
			{
				if ( i === swiper.activeIndex )
				{
					const muted = video.hasAttribute( 'muted' );

					if ( video.autoplay )
					{
						if ( muted )
						{
							video.muted = true;
						}

						video.play();
					}
				}
			} );
		}
	}

	/**
	 * 
	 * @param {Event} event 
	 */
	onVideoClick( event )
	{
		const video = event.target;

		if ( ! video.hasAttribute( 'controls' ) )
		{
			video.muted = ! video.muted;
		}
	}

}

export default BlockSlider;